import { zh } from './zh';
import { en } from './en';

export type Language = 'zh' | 'en';
export type Translations = typeof zh;

const translations = {
  zh,
  en,
};

// 获取浏览器默认语言
const getBrowserLanguage = (): Language => {
  const lang = navigator.language.split('-')[0];
  return (lang === 'zh' || lang === 'en') ? lang : 'en';
};

// 从 localStorage 获取保存的语言设置
const getStoredLanguage = (): Language | null => {
  const stored = localStorage.getItem('language');
  return (stored === 'zh' || stored === 'en') ? stored : null;
};

// 获取当前语言
export const getCurrentLanguage = (): Language => {
  return getStoredLanguage() || getBrowserLanguage();
};

// 设置语言
export const setLanguage = (lang: Language) => {
  localStorage.setItem('language', lang);
  window.location.reload(); // 刷新页面以应用新语言
};

// 获取翻译文本
export const t = (key: string): string => {
  const lang = getCurrentLanguage();
  const translation = translations[lang];
  
  // 支持嵌套对象的访问，例如 'profile.title'
  const keys = key.split('.');
  let result: any = translation;
  
  for (const k of keys) {
    if (result && typeof result === 'object' && k in result) {
      result = result[k];
    } else {
      return key;
    }
  }
  
  return typeof result === 'string' ? result : key;
}; 